import React from 'react';
import Icon from '../../../components/AppIcon';

const PTOStatsCards = ({ stats, loading }) => {
  const cards = [
    {
      label: 'Total Requests',
      value: loading ? '—' : stats?.totalRequests ?? 0,
      icon: 'CalendarDays',
      color: 'text-primary',
      bg: 'bg-primary/10',
    },
    {
      label: 'Pending Approval',
      value: loading ? '—' : stats?.pendingCount ?? 0,
      icon: 'Clock',
      color: 'text-warning',
      bg: 'bg-warning/10',
    },
    {
      label: 'Approved This Month',
      value: loading ? '—' : stats?.approvedThisMonth ?? 0,
      icon: 'CheckCircle',
      color: 'text-success',
      bg: 'bg-success/10',
    },
    {
      label: 'Avg Days Requested',
      value: loading ? '—' : (stats?.avgDays ?? 0)?.toFixed(1),
      icon: 'TrendingUp',
      color: 'text-accent',
      bg: 'bg-accent/10',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards?.map((card) => (
        <div key={card?.label} className="bg-card rounded-xl p-4 elevation-sm flex items-center gap-4">
          <div className={`w-10 h-10 rounded-lg ${card?.bg} flex items-center justify-center flex-shrink-0`}>
            <Icon name={card?.icon} size={20} className={card?.color} />
          </div>
          <div>
            <p className="text-2xl font-heading font-bold text-foreground">{card?.value}</p>
            <p className="text-xs font-caption text-muted-foreground">{card?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PTOStatsCards;
